// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, " \n.usa-info-header-button{\n  background-color:#0080FF;\n}\n\n.usa-info-header-button:hover{\n  background-color:#004080;\n}\n\n.highlighted-element{\n  box-sizing: border-box;\n  outline: 1px dashed red;\n  /* background-color: rgba(184, 192, 184, 0.5) !important; */\n}", ""]);
// Exports
module.exports = exports;
